import { defineStore } from 'pinia';

export const useNavbarStore = defineStore({
  id: 'navbar-store',
  state: () => {
    return {
      showSideBar: false,
      showNavbar: true,
      showDownloadCta: false,
      scrolled: false,
      readyToDisplay: false,
      footerTouch: false,
      logoColor: 'default',
      profileOpen: false,
      scrollProgress: 0,
    };
  },
  actions: {
    setScrollProgress (progress) {
      this.scrollProgress = progress;
    },
    async fetch () {

    },
    toggleSidebar () {
      this.showSideBar = !this.showSideBar;
    },

    closeSidebar () {
      this.showSideBar = false;
    },

    toggleDownloadCta () {
      this.showDownloadCta = !this.showDownloadCta;
    },

    closeDownloadCta () {
      this.showDownloadCta = false;
    },

    scrolledActive () {
      this.scrolled = true;
    },

    scrolledDisable () {
      this.scrolled = false;
    },

    hideNavbarValue () {
      this.showNavbar = false;
    },

    showNavbarValue () {
      this.showNavbar = true;
    },

    displayDocument () {
      this.readyToDisplay = true;
    },

    touchFooter () {
      this.footerTouch = true;
    },

    resetFooterTouch () {
      this.footerTouch = false;
    },

    changeLogoColor (color) {
      this.logoColor = color;
    },

    toggleProfile (payload) {
      this.profileOpen = payload;
    },
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useNavbarStore, import.meta.hot));
}
